module.exports = __webpack_public_path__ + "static/img/10.a1b0d10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/10.png
// module id = s0xQ
// module chunks = 0